// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"UserKioskSettings_inputGroup__10muk"};